export enum ErrorMessages {
	GenericError = 'Something went wrong. Please check your internet connection and try again.',
	GenericError2 = 'Something went wrong, please try again later',
	FlightsNoResults = 'There are no flights available for your search. Please change your search or try again later.',
	NoResults = 'There are no results for your search. Please change your search.',
	NewsItemsNotFound = 'There are no news items available at the moment. Please try again later.',
	SecurityCheckpointsNotFound = 'There are no security checkpoints available at the moment. Please try again later.',
	ParkingBookingStartTimeTooClose = 'Bookings must be made at least 12 hours before arrival',
	ShopAndDineNoResults = 'Please check your provided details and change your search input.',
	SolicitationsNotFound = 'There are no solicitations available at the moment. Please try again later.',
	SolicitationsNoResults = 'Try adjusting your filters to broaden your search.',
	ProposersNoResults = 'There are no Prospective Proposers yet, join the list to be the first one!',
	MediaNotFound = 'There is no media available at the moment. Please try again later.',
}
